import axios from "axios";
import { Message } from "element-ui";

const service = axios.create({
    // baseURL: "/api", //baseURL会自动加载到接口地址上 VUE_APP_API_ENV
    baseURL: process.env.VUE_APP_API_ENV == 'dev' ? '/api' : process.env.VUE_APP_API_URL1,
    timeout: 3000,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    }
});
console.log(999)
console.log(process.env.VUE_APP_API_URL1)
// 添加请求拦截器
service.interceptors.request.use((config) => {
    // 请求之前做些什么获取并设置token
    //   config.headers["token"] = getToken("token");
    console.log(config)
    return config;
}),
    (error) => {
        return Promise.reject(error);
    };
// 添加响应拦截器
service.interceptors.response.use((response) => {
    // 响应之后做些什么
    let { status, message } = response;
    if (status !== 200) {
        Message({
            message: message || "error",
            type: "warning",
        });
    }
    return response;
}),
    (error) => {
        return Promise.reject(error);
    };
export default service;
